import React, { ReactNode } from "react";

import styles from "../link-app.module.css";
import EmailLink from "./email-link";

type ErrorMessageProps = {
  title: string
  emailSubject: string
  emailBody?: string
  children: ReactNode
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  title,
  emailSubject,
  emailBody,
  children,
}) => (
  <>
    <h2 className={styles.h3}>{title}</h2>

    <p className={styles.largePara}>
      {children}
    </p>

    <EmailLink subject={emailSubject} body={emailBody} />
  </>
);

export default ErrorMessage;
